import {FormControlLabel, Switch} from "@mui/material";
import {useContext, useRef} from "react";
import {api} from "../../../api/API";
import {useBackgroundAction} from "../manage/sov/UseBackgroundTask";
import {ProjectContext} from "../ProjectProvider";
import {useSnackbar} from "../../../misc/Snackbar";

export function PricingPopup(props: {
    onClose: () => void;
}) {
    const proj = useContext(ProjectContext);

    const reloadRef = useRef(proj.reload);
    reloadRef.current = proj.reload;

    const snack = useSnackbar();
    const update = useBackgroundAction({
        callback: (input: Parameters<typeof api.projects.setPausePricing>[0]) => api.projects.setPausePricing(input),
        onDone: (value: {
            paused: boolean
        }) => {

            reloadRef.current();
            props.onClose();

            if(value.paused) {
                snack.success("Fast Mode enabled");
            } else {
                snack.success("Auto Pricing enabled");
            }
        },
    });

    return <div style={{padding: 16, paddingTop: 4, paddingBottom: 4}}>
        <FormControlLabel
            control={<Switch size="small" checked={proj?.value.quotePausePricing || false} onChange={(_, checked) => {
                snack.loading();

                update.callback({
                    project: proj?.value.id || 0,
                    pause: checked,
                });
            }} />}
            label={
                <span style={{fontSize: "0.8rem"}}>Pause Pricing (Fast Mode)</span>
            } />
        {update.LoadingElement}
    </div>
}